"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectIsCloudProxy = void 0;
var _reselect = require("reselect");
var _ReadinessCheck = require("@studio/constants/ReadinessCheck");
var selectReadinessCheck = function selectReadinessCheck(state) {
  return state.readinessCheck;
};
var selectIsCloudProxy = exports.selectIsCloudProxy = (0, _reselect.createSelector)(selectReadinessCheck, function (readinessCheck) {
  return readinessCheck.proxyType !== _ReadinessCheck.NO_PROXY_SERVER;
});